import { Controller } from "@hotwired/stimulus"
import React from 'react';
import {createRoot} from 'react-dom/client';
import WorkoutVideo from '../components/WorkoutVideo';

// Connects to data-controller="workout_video"
export default class extends Controller {
  static values = {
    src: String,
    dir: Array,
  };

  connect() {
      const root = createRoot(this.element);
      root.render(<WorkoutVideo vidSrc={this.srcValue} thumbs={this.dirValue} />);
  }
}
